// Styles for filter elements

export const filterStyles = {
    inline: {display: 'inline-block', verticalAlign: 'top', marginRight: '1em'},
    break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0, paddingBottom: '1em'},
    hidden: {display: 'none', visibility: 'hidden'},

    fieldInstructions: {margin: '2em 0 0 0'},
    fieldTextWide: {display: 'block', maxWidth: '80%'},

    selectInput: {minWidth: 50, marginTop: 0, marginRight: '1em'},
    selectInputTime: {width: 80, marginTop: 0, marginRight: '1em'},
    selectInputSmall: {minWidth: 50, maxWidth: 150, marginTop: 0, marginRight: '1em'},
    selectInputWide: {minWidth: 300, marginTop: 0},
    textInputWide: {display: 'inline-block', height: 75, verticalAlign: 'baseline', minWidth: 300, marginRight: '1em'},
    checkbox: {display: 'inline-block', verticalAlign: 'middle', minWidth: 100, whiteSpace: 'nowrap', marginBottom: 2, marginRight: '1em'},

    submitButton: {marginTop: '0.5em'},
    submitButtonInline: {marginTop: '0.5em', marginLeft: '0.5em'}

};



// WEBPACK FOOTER //
// ./src/Fuse/shared/styles-filter.js